<template>
<div>
    <div class="menu">
        <div class="row">
            <div class="col s12">
        <label>
            <span>Reference language</span>
        </label>
        <div style="width: 20%; display:inline-block; margin-left:2rem">
            <select v-model="secondaryLanguage">
            <option v-if="$store.languages.length > 0" value="" disabled selected>Choose a language</option>
            <option v-if="$store.languages.length == 0">No languages were found</option>
            <option v-for="(language,index) in $store.languages" :key="index" v-bind:value="language.id">{{language.name}}</option>
            </select>
        </div>
        </div>
    </div>
        
    </div>
    <div class="row">
        <div class="col s12">
            <div class="card">
                <ul v-show="!loading" class="browser-default dialog-tree-row">
                    <TranslateTreeItem v-for="(dialog, index) in nextDialogs" :key="index" :itemNumber="''" :secondaryLanguage="secondaryLanguage"  :dialog="dialog" :parentOpen="true"/>
                </ul>
                <div v-if="loading">
                    <h4 class="center-align">Loading dialog editor...</h4>
                    <Spinner class="center"/>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<style scoped>
.dialog-tree-row {
  list-style-type: none;
  padding-left: 1em;
}
.card {
  padding: 1em;
}
.center {
  position: relative;
  left: 50%;
}
.btn-small {
  height: 28px;
  line-height: 28px;
  font-size: 13px;
  padding: 0 1rem;
  margin-bottom: 2px;
}

.center {
  position: relative;
  left: 50%;
  margin-top: 5%;
}

.menu {
  background-color: #ffffff;
  margin-bottom: 1em;
  border-bottom: #ddd solid 1px;
  padding: 0.5em 0.75rem;
  min-height: 70px; 
  line-height: 3em
}

.menu input {
  width: 30%;
  border-radius: 1px;
  border: 1px solid #d9d9d9;
  border-top: 1px solid #c0c0c0;
  font-size: 14px;
  height: 2em;
  padding: 1px 8px;
}

.menu input:focus {
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.3);
  border: 1px solid #4d90fe;
  outline: none;
  width: 50%;
}

.row {
  margin-bottom: 0 !important;
}
</style>
<script>
/**
 * View for displaying a dialog tree
 */
import TranslateTreeItem from "../components/TranslateTreeItem";
import Spinner from "../components/Spinner";

export default {
  name: "translateTree",
  components: { TranslateTreeItem, Spinner },
  data() {
    return {
      nextDialogs: {},
      loading: true,
      displaySecondaryLanguage: false,
      secondaryLanguage: ""
    };
  },
  methods: {
    /**
     * Retrieves dialogs based on a tag
     * @param {any} tag Tag to use for query
     */
    getDialogByTag(tag) {
      return new Promise((resolve, reject) => {
        this.$http.get("/dialogs?tag=" + tag).then(
          response => {
            response.data.forEach(element => {
              if (!element.next) element.next = [];
              this.$set(this.nextDialogs, element.id, element);
            });
            resolve();
          },
          response => {
            reject(response);
          }
        );
      });
    },
    /**
     * Handle incomming dialog update (add or update dialog)
     */
    handleDialogUpdate(dialog) {
      this.$store
        .putDialog(dialog)
        .then(() => {
          this.$set(this.nextDialogs, dialog.id, dialog);
        })
        .catch(() =>
          M.toast({
            html: "Could not update dialog"
          })
        );
    }
  },
  mounted(){
    M.FormSelect.init(document.querySelectorAll("select"), {});
  },
  created() {
    this.$on("update:dialog", d => this.handleDialogUpdate(d));
      this.getDialogByTag("start")
        .then(() => (this.loading = false))
        .catch(() => (this.loading = false));
  },
  updated() {
    M.FormSelect.init(document.querySelectorAll("select"), {});
  }
};
</script>



// WEBPACK FOOTER //
// src/views/TranslateTree.vue